#import "../ChartOfAccountFields.graphql"

mutation ChartOfAccountCreate($input: ChartOfAccountCreateInput!) {
  chartOfAccountCreate(input: $input) {
    chartOfAccount {
      ...ChartOfAccountFields
    }
  }
}
